import { render, staticRenderFns } from "./ConversationDetailsModal.vue?vue&type=template&id=3487e872&scoped=true"
import script from "./ConversationDetailsModal.vue?vue&type=script&lang=ts"
export * from "./ConversationDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./ConversationDetailsModal.vue?vue&type=style&index=0&id=3487e872&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487e872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3487e872')) {
      api.createRecord('3487e872', component.options)
    } else {
      api.reload('3487e872', component.options)
    }
    module.hot.accept("./ConversationDetailsModal.vue?vue&type=template&id=3487e872&scoped=true", function () {
      api.rerender('3487e872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/ConversationDetailsModal.vue"
export default component.exports